import { FunctionComponent, ReactNode, useContext, useState } from 'react';
import { FileUploadItem } from './fileUploadItem';
import { Trans } from 'react-i18next';
import { AlertContext } from '../alert-snackbar/alert-context';
import { useAssetsQuery } from '../../queries/assets-query';
import {
  Alert,
  Box,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';

interface IAssetManagementProps {
  getIdToken: () => Promise<string>;
}

export const AssetManagement: FunctionComponent<IAssetManagementProps> = ({ getIdToken }) => {
  const [language, setLanguage] = useState('de');
  const { data: assets, isLoading: isLoadingAssets } = useAssetsQuery(getIdToken, language);
  const alertContext = useContext(AlertContext);

  const handleOnSuccess = () => {
    alertContext.enqueueAlert({
      type: 'success',
      i18nKey: 'settings.assets.onSuccess',
    });
  };

  const handleOnError = () => {
    alertContext.enqueueAlert({
      type: 'error',
      i18nKey: 'settings.assets.onError',
    });
  };

  const handleLanguageChange = (event: SelectChangeEvent<string>, child: ReactNode) => {
    setLanguage(event.target.value as string);
  };

  return (
    <Box sx={{ backgroundColor: '#e1e1e1', padding: 4 }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <FormControl sx={{ width: '300px' }} variant="outlined">
            <InputLabel id={'lang-input-label'}>
              <Trans i18nKey={'settings.selectLanguages'} />
            </InputLabel>
            <Select
              labelId={'lang-input-label'}
              label={<Trans i18nKey={'settings.selectLanguages'} />}
              onChange={handleLanguageChange}
              value={language}
            >
              <MenuItem value={'de'}>
                <Trans i18nKey={'settings.languages.de'} />
              </MenuItem>
              <MenuItem value={'en'}>
                <Trans i18nKey={'settings.languages.en'} />
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
        {isLoadingAssets ? (
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <CircularProgress />
            </Box>
          </Grid>
        ) : (
          (assets || []).map((asset) => (
            <Grid item md={6} xs={12} key={`item-${asset.key}-de`}>
              <FileUploadItem
                getIdToken={getIdToken}
                asset={asset}
                onError={handleOnError}
                onSuccess={handleOnSuccess}
                language={language}
              />
            </Grid>
          ))
        )}
        <Grid item xs={12}>
          <Alert severity={'warning'}>
            <Trans i18nKey={'settings.assets.cachingNote'} />
          </Alert>
        </Grid>
      </Grid>
    </Box>
  );
};
